//展板模板
<template>
    <div class="filterBox">
        <div class="breedList">
            <span class="name">品名：</span>
            <div class="item" :class="{'itemTrue':index== itemTrue,'itemHide':index>5 && !breedShow}" @click="breedSelect(item,index)" v-for="(item,index) in breedData" :key="index">
                {{item.breed}}
            </div>
            <div class="breedShow" @click="breedShow= !breedShow">{{breedShow?'收起':'更多'}}</div>
            <div class="execlInsert execlInsertHasFilter clearfix excelExper">
                <span class="excel_btn" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="offerTable">
            <el-table
            :data="list"
            v-loading="loading"
            element-loading-text="拼命加载中。。。"
            border
            size='mini'
            max-height="300px"
            :cell-style="{textAlign:'center'}"
            :header-cell-style="{background:'#f4f5f9',color:'#333',textAlign:'center'}"
            style="width: 100%">
            <el-table-column
                v-for="(item,index) in tableColList"
                :key="index"
                show-overflow-tooltip
                :prop="item.colKey"
                :label="item.colName"
                class="tableTrue"
                :width="item.colWidth">
                <template slot-scope="scope">
                    {{scope.row[item.colKey]}}
                </template>
            </el-table-column>
            </el-table>
            <div style="padding-top:15px">
                <span v-if="this.sales_strategy">销售策略：{{this.sales_strategy}}</span>
                <br/>
                <span v-if="this.boss_message">BOSS留言：{{this.boss_message}}</span>
            </div>
        </div>
    </div>
</template>
<script>
    import tabletem from './table.vue';
    export default {
        components:{
            tabletem
        },
        data(){
            return{
                breedData:[],
                tableCol:[
                    {colName:"等级",colKey:"grade",colWidth:90,isCanClick:false,backClick:false},
                    {colName:"品牌",colKey:"brand",colWidth:90,isCanClick:true,backClick:false},
                    {colName:"产地",colKey:"place_origin",colWidth:100,isCanClick:false,backClick:true},
                    {colName:"选色",colKey:"color",colWidth:90,isCanClick:false,backClick:false},
                ],
                tableColList:[],
                list:[],
                sales_strategy:'',
                boss_message:'',
                itemTrue:0,
                loading: false,
                breedShow:false,
            }
        },
        created(){
            this.getData();
        },
        mounted(){
            
        },
        methods:{
            // 获取品名
            getData(){
                this.postFunc('/erp/sales.price.breed',{},res=>{
                    if(res.data.code == 0){
                        this.breedData = res.data.data;
                        this.getOfferData(res.data.data[0]);
                    }
				},err=>{

                })
            },
            exportExcelBill(){
                this.$exportExecl("/erp/sales.price.plate.export","实时报价单导出",this.params)
            },
            // 获取报价单数据
            getOfferData(data){
                let params = {
                    breed_id:data.id
                }
                this.loading = true;
                this.postFunc('/erp/sales.price.plate',params,res=>{
                    this.loading = false;
                    if(res.data.code == 0){
                        this.list = res.data.data.data;
                        let arrs = res.data.data.messages;
                        this.sales_strategy = arrs.sales_strategy;
                        this.boss_message = arrs.boss_message;
                        let arr = [];
                        let newArr = this.listDifference(res.data.data.columns,this.tableCol);
                        if(newArr){
                            newArr.forEach(item => {
                                arr.push({
                                    colName:item,
                                    colKey:item,
                                    colWidth:120,
                                    isCanClick:false,
                                    backClick:false
                                })
                            });
                        }
                        // if(res.data.data.columns){
                        //     let newArr = [];
                        //     let arr = res.data.data.columns;
                        //     for(let i=0;i < arr.length;i++){
                        //         newArr.push({
                        //             colName:arr[i],
                        //             colKey:arr[i],
                        //             colWidth:120,
                        //             isCanClick:false,
                        //             backClick:false
                        //         })
                        //     }
                        // }
                        
                        this.tableColList = this.tableCol.concat(arr);
                    }else{
                        this.loading =true
                    }
                },err=>{

                })
            },

            // 选择品名
            breedSelect(data,index){
                this.itemTrue = index;
                this.getOfferData(data);
            },

            listDifference(x,y){
                let clone = x.slice(0);
                for (let i = 0; i < y.length; i++) {
                    let temp = y[i];
                    for (let j = 0; j < clone.length; j++) {
                        if (temp.colKey == clone[j]) {
                            clone.splice(j, 1);
                        }
                    }
                }
                return clone;
            }
        },
        watch:{
            
        }
    }
</script>
<style scoped>
    .full_dialog .el-dialog__body{padding:10px 20px 10px 20px;}
    .breedList{display: flex;flex-direction: row;flex-wrap: wrap;margin-bottom: 10px;position: relative;}
    .breedList .name{height: 32px;line-height: 32px;font-weight: 600;font-size: 12px;}
    .breedList .item{margin-left: 5px;margin-bottom: 5px; border:1px solid #b21111;color: #b21111;border-radius: 3px;min-width: 85px;height: 32px;line-height: 28px;text-align: center;position: relative;cursor: pointer;}
    .breedList .itemHide{display: none;}
    .breedList .itemTrue:after{display: block;content: "";width: 21px;height: 21px;position: absolute;right: 0;bottom: 0;background: url(/icon/checkeded.png) no-repeat;background-size: cover;}
    .excelExper{position: initial; height: 32px;margin: 0;text-align: center;width: 90px; display: flex;justify-content: center;}
    .breedShow{height: 32px;display: flex;align-items: center;justify-content: center;cursor: pointer;width: 60px;}
</style>